import { render, staticRenderFns } from "./UserManagementTotalGgrTab.vue?vue&type=template&id=4b4e0896&scoped=true&lang=pug"
import script from "./UserManagementTotalGgrTab.vue?vue&type=script&lang=ts"
export * from "./UserManagementTotalGgrTab.vue?vue&type=script&lang=ts"
import style0 from "./UserManagementTotalGgrTab.vue?vue&type=style&index=0&id=4b4e0896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e0896",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCardTitle,VCol,VDataTable,VIcon,VRow})
